
const RunnableViewModel = function(params) {
  var self = this;

  self.defaults = {
    courseId: null,
    courseworkId: null,
    entryId: null,
    $el: $('#ko_runnable'),
    $runnableDemo: $('#runnable_demo'),
  };

  self.config = _.extend({}, self.defaults, params);

  self.runnableCode = ko.observable('Loading...');
  self.runnableFiles = ko.observableArray([]);
  self.runnablePath = ko.observable('');
  self.selectedFile = ko.observable('');
  self.errorState = ko.observable(false);
  self.fileToLarge = ko.observable(false);

  self.curPrismClassName = ko.computed(function() {
    return !s.isBlank(self.selectedFile()) ? 'language-' + self.selectedFile().prism_class_name : '';
  });

  self.selectedFile.subscribe(function(file) {
    if (file && file.source) {
      self.runnableCode(file.source);

      //Only highlight files that have than 10k lines of code
      var lines = file.source.split(/\r\n|\r|\n/).length;
      if (lines < 1000) {
        setTimeout(function(){ Prism.highlightAll(); }, 100);
      }
    }
  });

  self.initUI = function() {
    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.course_gallery_coursework_coursework_field_entry_runnable_path(self.course_id, self.coursework_id, self.coursework_field_entry_id),
      method: 'POST',
      loadingIndicator: {
        container: self.config.$el,
        positionTop: 'absolute'
      },
      timeout: 300000 // 5 minutes
    });

    request.success(function(data, textStatus, xhr) {
      if(!data.url) {
        self.errorState(true);
        return;
      }

      self.config.$runnableDemo.attr('src', data.url);

      self.runnablePath(data.path);
      self.runnableFiles(data.files);
      self.selectedFile(_.find(data.files, function(file) { return file.is_entry_point; }));

      Prism.highlightAll();
    });

    request.error(function(xhr, textStatus, errorThrown) {
      self.fileToLarge(xhr.responseJSON && xhr.responseJSON.messages === 'file_to_large');
      self.errorState(true);
    });

    $(window).off('beforeunload.runnable').on('beforeunload.runnable', function(event) {
      self.destroy();
    });
  };

  self.destroy = function () {
    self.config.$runnableDemo.attr('src', null);
    new Kadenze.AjaxRequest({
      url: Kadenze.Routes.course_gallery_coursework_coursework_field_entry_runnable_path(self.course_id, self.coursework_id, self.coursework_field_entry_id),
      data: {path: self.runnablePath()},
      method: 'DELETE',
      async: false
    });
  };

  const __construct = function(that) {
    that.coursework_field_entry_id = self.config.entryId || $('#coursework_field_entry_id').val();
    that.coursework_id = self.config.courseworkId || $('#coursework_id').val();
    that.course_id = self.config.courseId || $('#course_id').val();
  }(this);
};

export default function(params) {
  const self = this;

  self.id = params['id'];
  self.type = 'Runnable';
  self.src = params['src'];
  self.$node = $(params['node']);

  self.runnableConfig = {
    courseId: params['courseId'],
    courseworkId: params['courseworkId'],
    entryId: params['id'],
    $el: self.$node.find('.js-ko-runnable'),
    $runnableDemo: self.$node.find('.js-ko-runnable-demo')
  };

  self.init = () => {
    let node = self.runnableConfig.$el.get(0);
    self.runnableView = new RunnableViewModel(self.runnableConfig); //TODO: Move RunnableViewModel logic in here

    ko.cleanNode(node);
    ko.applyBindings(self.runnableView, node);
    self.runnableView.initUI();
  };

  self.pause = function () {
    self.runnableView.destroy();
  };

  self.init();

  return self;
}

